import React from 'react';
import { LoginLayout } from 'layout';
import '@isyc-react/design/main';
import 'assets/css/login.css';
import { RestorePasswordForm } from 'common/auth/modules/pods/login';
import { cleanJwt } from 'common/api/srm-api';
import { AuthStatus, useAuthContext } from 'common/auth/modules/context';
import { useQueryClient } from '@tanstack/react-query';
export const RestorePasswordScene = () => {
    const { setUserSession } = useAuthContext();
    const queryClient = useQueryClient();
    React.useEffect(() => {
        cleanJwt();
        queryClient.clear();
        setUserSession(v => (Object.assign(Object.assign({}, v), { status: AuthStatus.NOT_LOGGED, user: null })));
    }, [queryClient, setUserSession]);
    return (React.createElement(LoginLayout, null,
        React.createElement(RestorePasswordForm, { successButton: true })));
};
